import { createActionTypes } from "@helpers/redux-helpers";

export const addStripeActionType = createActionTypes("stripe/add");

export const clearStripeActionType = createActionTypes("stripe/clearStates");

export const getStripeCountriesActionTypes = createActionTypes(
  "stripe/countries/get",
);
